module.exports = __webpack_public_path__ + "img/volumeMuted.dc6587b7.svg";